import { Component, Input, OnInit } from "@angular/core";
import { IObservationInfo } from "@comunicare/comunicare-interfaces";
import * as moment from "moment";

interface ObservationsByDate {
  date: string;
  observations: IObservationInfo[];
}

@Component({
  selector: "app-observation-last-available",
  templateUrl: "./observation-last-available.component.html",
  styleUrls: ["./observation-last-available.component.scss"],
})
export class ObservationLastAvailableComponent implements OnInit {
  @Input() observations: IObservationInfo[];

  groupedObservations: ObservationsByDate[] = [];

  ngOnInit() {
    this.groupObservationsByDate();
  }

  private groupObservationsByDate(): void {
    if (!this.observations || this.observations.length === 0) {
      return;
    }

    const observationsMap: Record<string, IObservationInfo[]> = {};

    this.observations.forEach((observation) => {
      const dateKey = moment(observation.issued).format("YYYY-MM-DD");

      if (!observationsMap[dateKey]) {
        observationsMap[dateKey] = [];
      }

      observationsMap[dateKey].push(observation);
    });

    this.groupedObservations = [];
    for (const date in observationsMap) {
      this.groupedObservations.push({
        date: date,
        observations: observationsMap[date],
      });
    }

    this.groupedObservations.sort((a, b) => {
      return moment(b.date).valueOf() - moment(a.date).valueOf();
    });
  }
}
